import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
export const FooterIcon = ({ href, ariaLabel, className, icon: Icon }) => {
    return (_jsx(_Fragment, { children: href ? (_jsx("a", { href: href, "aria-label": ariaLabel, className: classNames('text-gray-500 dark:hover:text-white', className), children: _jsx(Icon, { className: "h-5 w-5" }) })) : (_jsx(Icon, { className: "h-5 w-5" })) }));
};
